import { isIteDomain } from "./getLogo";

export const applyTheme = () => {
    if (isIteDomain()) {
        document.documentElement.style.setProperty("--orange", "#95C71F");
        document.documentElement.style.setProperty("--orange-hover", "#678818");

        document.title = "ITEPREVENGO CAPACITACIONES";

        const favicon = document.querySelector("link[rel='icon']");
        if (favicon) {
            favicon.href = "/favicon-iteprevengo.ico";
        }
    }
};
